import { isEmptyOrNil } from '@/utils'
import { ValidatorNodeFormat } from '@/enums'
export const dealMoniker = (value: string) => {
  if (isEmptyOrNil(value)) return '-'
  const val = `${value}`!.replace(/-node$/, '')
  if (ValidatorNodeFormat[val.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat]) {
    return ValidatorNodeFormat[val.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat]
  }
  return val
}
